import { classeDaPlataforma, iconeDaPlataforma } from './canais';

/** Quadrado 28px com a cor da marca e o ícone dentro. */
const CanalIcone = ({ plataforma, size = 14, className = '' }: { plataforma: number; size?: number; className?: string }) => (
    <span className={`cx-bx ${classeDaPlataforma(plataforma)} ${className}`} aria-hidden="true">
        {iconeDaPlataforma(plataforma, size)}
    </span>
);

export default CanalIcone;
